/**
 * Top-up (เติมหยก): หยกเซียน bought with real money. The first purchase of each pack pays its jade
 * twice, and the running total unlocks milestone rewards. Like the mall, nothing here adds power.
 */
export interface TopUpPack {
  readonly id: string;
  /** Price in baht. */
  readonly baht: number;
  readonly jade: number;
  /** Extra jade on every purchase. */
  readonly bonus: number;
  readonly tag?: string;
}

export const TOPUP_PACKS: readonly TopUpPack[] = [
  { id: 'jade-60', baht: 29, jade: 60, bonus: 0 },
  { id: 'jade-300', baht: 149, jade: 300, bonus: 15 },
  { id: 'jade-680', baht: 299, jade: 680, bonus: 50, tag: 'คุ้มค่า' },
  { id: 'jade-1280', baht: 599, jade: 1280, bonus: 130 },
  { id: 'jade-3280', baht: 1490, jade: 3280, bonus: 400, tag: 'ยอดนิยม' },
  { id: 'jade-6480', baht: 2990, jade: 6480, bonus: 1000 },
];

/** Rewards for the total baht ever topped up, claimed once each. */
export interface TopUpMilestone {
  readonly baht: number;
  readonly jade?: number;
  readonly gold?: number;
  readonly skin?: string;
  readonly mount?: string;
}

export const TOPUP_MILESTONES: readonly TopUpMilestone[] = [
  { baht: 100, jade: 50, gold: 5000 },
  { baht: 500, jade: 100, skin: 'purple-dew' },
  { baht: 1500, mount: 'eagle' },
  { baht: 3000, jade: 500, skin: 'violet-fan-swords' },
];

/** What the payment side hands over once money has been taken. */
export interface TopUpReceipt {
  /** Unique per payment; a receipt is credited once. */
  readonly id: string;
  readonly pack: string;
  readonly baht: number;
}

/** Jade a purchase pays: the pack, its bonus, and the pack again the first time it is bought. */
export function topUpJade(pack: TopUpPack, first: boolean): number {
  return pack.jade + pack.bonus + (first ? pack.jade : 0);
}

/** How many receipt ids a save remembers to refuse paying the same one twice. */
export const TOPUP_RECEIPTS_KEPT = 100;
